"use client";
import { useEffect } from "react";

import {
  ModalDialogBody,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogRoot,
  Spinner,
} from "@zapier/design-system";

import {
  emitUserInteractionEvent,
  UserInteractionEventName,
} from "src/observability/tracking";

import styles from "./TemplateCreationModal.module.css";
import { Template } from "src/types";

type Props = {
  template: Template;
};

export const TemplateCreationModal = ({ template }: Props) => {
  const { slug, id: templateId } = template;

  useEffect(() => {
    emitUserInteractionEvent(
      UserInteractionEventName.templateLoadingScreenViewed,
      {
        event_action: "in_view",
        option_selected: slug,
        custom_tracking_fields: {
          template_id: templateId,
        },
      },
    );
  }, [slug, templateId]);

  const productsList = (template.products ?? [])
    .map((product, _, array) =>
      product?.slug === array.at(-1)?.slug && array.length > 1
        ? `and ${product?.nameSingular}`
        : product?.nameSingular,
    )
    .join(", ");

  return (
    <ModalDialogRoot isOpen isDismissable={false}>
      <ModalDialogHeader textAlign="center">
        Building your workflow...
      </ModalDialogHeader>
      <ModalDialogBody textAlign="center">
        <p>Hold tight! Your shiny new {productsList} will be ready soon.</p>
      </ModalDialogBody>
      <ModalDialogFooter>
        <div className={styles.footer}>
          <Spinner />
        </div>
      </ModalDialogFooter>
    </ModalDialogRoot>
  );
};
